export const userType = {
    1: 'employee',
    2: 'visitor',
    3: 'contractor_in_charge',
    4: 'contractors_employee',
    5: 'supplier_in_charge',
    6: 'supplier_employee',
};
export const USER_TYPE_MODEL = {
    EMPLOYEE: 1,
    VISITOR: 2,
    CONTRACTOR_IN_CHARGE: 3,
    CONTRACTORS_EMPLOYEE: 4,
    SUPPLIER_IN_CHARGE: 5,
    SUPPLIER_EMPLOYEE: 6,
}
export const USER_TYPE_NAME_MODEL = {
    NONE:"NONE",
    EMPLOYEE: 'EMPLOYEE',
    VISITOR: 'VISITOR',
    CONTRACTOR_IN_CHARGE: 'CONTRACTOR_IN_CHARGE',
    CONTRACTORS_EMPLOYEE: 'CONTRACTORS_EMPLOYEE',
    CONTRACTOR:'CONTRACTOR',
    SUPPLIER_IN_CHARGE: 'SUPPLIER_IN_CHARGE',
    SUPPLIER_EMPLOYEE: 'SUPPLIER_EMPLOYEE',
    PROVIDER:"PROVIDER"
}

export const USER_ACCESS_KEY_MODEL = {
    CONTRACTORS:"contractors",
    CONTRACTOR:"contractor",
    SUPPLIERS:"suppliers",
    SUPPLIER:"supplier",
    CONTRACTS:"contracts",
    EMPLOYEE:"employee",
    CONTRACTOR_EMPLOYEE:"contractorEmployee",
    SUPPLIER_EMPLOYEE:"supplierEmployee",
    CONTRACTOR_VEHICLE:"contractorVehicle",
    SUPPLIER_VEHICLE:"supplierVehicle",
    EMPLOYEE_VEHICLE:"employeeVehicle"
}

export const USER_TYPE_DOCUMENT = {
    EMPLOYEE_DOCUMENT: 'employee_document',
    CONTRACTOR_DOCUMENT: 'contractor_document',
    CONTRACTOR_VEHICLE_DOCUMENT:"contractor_vehicle_document",
    SUPPLIER_DOCUMENT: 'supplier_document',
    SUPPLIER_VEHICLE_DOCUMENT:"supplier_vehicle_document"

};

export const ROLE_NAME_DEFAULT_MODEL = {
    ROLE_GUARD : 'GUARD',
    ROLE_NONE : 'NONE',
    ROLE_ROOT : 'ROOT',
}
